<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
                <h4 class="personal-details-title">Update Route Controller </h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Route Name</th>
                      <th scope="col">Route Status</th>
                      <th scope="col">Action</th>
                     
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of RouteData | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: page,
                      totalItems: count
                     };let i = index">
                      <th scope="col">{{i+1}}</th>
                      <th scope="col">{{data.routeName}}</th>
                      <th scope="col">{{data.routeStatus}}</th>
                      <th>
                        <svg (click)="getRouteById(data.routeId)" data-toggle="modal" data-target="#updateModal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                            <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                        </svg> 
                      </th>
                    </tr>
                       
                  </tbody>
              </table>
              <div class="pagination-block" *ngIf="RouteData.length != 0">
                <pagination-controls
                  previousLabel="Prev"
                  nextLabel="Next"
                  (pageChange)="onTableDataChange($event)"
                >
                </pagination-controls>
            </div>
  
        </div>
    </div>
</div>



<div class="modal fade" id="updateModal" tabindex="-1"  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modify Route Controller
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="form">
            <div class="row" >
                <div class="col-md-12 col-lg-12">
                  <div class="form-group">
                    <label>Route Name</label>
                    <input formControlName="routeName" type="text" class="form-control">
                  </div>
                </div>
            </div>
        </div>
      <div class="modal-footer">
        <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="updateRoute()" class="btn btn-primary" data-dismiss="modal">save changes</button>
      </div>
    </div>
  </div>
  </div>
</div>





